<template>
  <md-card class="md-card-profile">
    <div class="md-card-avatar">
      <img class="img" :src="cardUserImage" />
    </div>

    <md-card-content>
      <h5 class="category text-gray">
        {{ userDisplay.company_name }}
      </h5>
      <h6 class="category text-gray">{{ userDisplay.company_position }}</h6>
      <h3 class="card-title">
        {{ userDisplay.first_name }} {{ userDisplay.last_name }}
      </h3>
    </md-card-content>
  </md-card>
</template>
<script>
export default {
  name: "user-card",
  props: {
    cardUserImage: {
      type: String,
      default: "./img/default-avatar.png"
    },
    userDisplay: Object
  },
  data() {
    return {};
  },
  mounted() {
	console.log(this.userDisplay);
  }
};
</script>
<style lang="scss">
  .card-title {
    margin-top: 3px;
    margin-bottom: 3px;
  }
  .trial {
    margin: 3px 0;
  }
</style>
